// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["css/app-ar","css/app-en"], () => (__webpack_require__("./resources/js/app.js")))
__webpack_require__.O(undefined, ["css/app-ar","css/app-en"], () => (__webpack_require__("./resources/sass/ar/app-ar.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["css/app-ar","css/app-en"], () => (__webpack_require__("./resources/sass/en/app-en.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
